/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React from 'react';
import historyContext from '../contexts/history-context';
import mapContext from '../contexts/map-context';

export function useMapQueryParam() {
  const { historyService } = historyContext.useHistoryState();
  const {
    query,
    userSelectedFilters,
    searchGeoLocation,
    selectedDealerId,
    selectedPartner,
    favoritePartner,
    isFlyoutOpen,
  } = mapContext.useMapState();

  function processSearchParams() {
    const searchParams: Record<string, string> = {
      query: '',
      'geolocation-lat': '0',
      'geolocation-lng': '0',
      filters: '',
      'dealer-id': '',
      selected: '',
      country: '',
      favorite: '',
      reviews: '',
    };
    if (!query) {
      delete searchParams.query;
    } else {
      searchParams.query = query;
    }
    if (userSelectedFilters.length === 0) {
      delete searchParams.filters;
    } else {
      searchParams.filters = userSelectedFilters.join(',');
    }
    if (searchGeoLocation.lat === 0 && searchGeoLocation.lng === 0) {
      delete searchParams['geolocation-lat'];
      delete searchParams['geolocation-lng'];
    } else {
      searchParams['geolocation-lat'] = searchGeoLocation.lat.toString();
      searchParams['geolocation-lng'] = searchGeoLocation.lng.toString();
    }
    if (!selectedDealerId) {
      delete searchParams['dealer-id'];
    } else {
      searchParams['dealer-id'] = selectedDealerId;
    }
    if (!selectedPartner) {
      delete searchParams.selected;
      delete searchParams.country;
    } else {
      if (!selectedPartner.kvpsid || selectedPartner.kvpsid === 'null') {
        delete searchParams.selected;
      } else {
        searchParams.selected = selectedPartner.kvpsid;
      }
      if (!selectedPartner.tenant || selectedPartner.tenant === 'null') {
        delete searchParams.country;
      } else {
        searchParams.country = selectedPartner.tenant;
      }
    }
    if (!favoritePartner || !favoritePartner.kvpsid || favoritePartner.kvpsid === 'null') {
      delete searchParams.favorite;
    } else {
      searchParams.favorite = favoritePartner.kvpsid;
    }
    if (!isFlyoutOpen) {
      delete searchParams.reviews;
    } else {
      searchParams.reviews = 'true';
    }
    return searchParams;
  }

  React.useEffect(() => {
    const urlSearchParams: Record<string, string> = processSearchParams();
    const searchParams = new URLSearchParams(urlSearchParams);
    if (Object.keys(urlSearchParams).length) {
      historyService?.history.replace(`?${searchParams}`);
    }
  }, [
    query,
    userSelectedFilters,
    searchGeoLocation,
    selectedDealerId,
    selectedPartner,
    favoritePartner,
    isFlyoutOpen,
  ]);
}
